import { useHistory } from "react-router-dom";
import { ButtonVariant } from "@merge-api/merge-javascript-shared";
import ErrorPage from "./ErrorPage";
import MantaNotFound from "../../../assets/svg/merge-manta-404.svg";
import { INTEGRATION_DASHBOARD_PATH } from "../../../router/RouterUtils";

const NotFoundPage = () => {
  // hooks
  const history = useHistory();

  // render
  return (
    <ErrorPage
      illustration={MantaNotFound}
      illustrationAlt="Merge Manta searching a map"
      code="404"
      title="A small case of lost"
      message="We’ve searched this corner of the reef. No page yet."
      actionLabel="Go to Integrations"
      actionVariant={ButtonVariant.TextBlue}
      onAction={() => history.push(INTEGRATION_DASHBOARD_PATH)}
    />
  );
};

export default NotFoundPage;
